export default {
	functional: true,
	render: (_, { children }) => children,
};
